// Konfiguration der generischen Rechner-Landingpages. Geteilt von React-Pages
// und scripts/prerender.js (vm-Shim, daher reines `export const`).
export const RECHNER_SEITEN = [
  {
    slug: "prozentrechner",
    key: "prozent",
    name: "Prozentrechner",
    tagline: "Prozente, Anteile und prozentuale Veränderungen berechnen.",
    title: "Prozentrechner: Prozent, Anteil und Veränderung berechnen",
    description: "Kostenloser Prozentrechner: X % von einem Wert, Anteil in Prozent und prozentuale Veränderung in Sekunden ausrechnen.",
    h1: "Prozentrechner",
    intro: "Rechne Prozente in drei Varianten: wie viel sind X % von einem Wert, welcher Anteil in Prozent ist ein Teil vom Ganzen, und wie groß ist die prozentuale Veränderung von einem Wert zum anderen.",
    faq: [
      { q: "Wie berechne ich X Prozent von einem Wert?", a: "Wert mal Prozent geteilt durch 100. Beispiel: 19 % von 200 = 200 × 19 ÷ 100 = 38." },
      { q: "Wie viel Prozent ist ein Teil vom Ganzen?", a: "Teil geteilt durch Grundwert mal 100. Beispiel: 38 von 200 = 38 ÷ 200 × 100 = 19 %." },
    ],
  },
  {
    slug: "mehrwertsteuer-rechner",
    key: "mwst",
    name: "Mehrwertsteuer-Rechner",
    tagline: "Netto, Brutto und Mehrwertsteuer (19 % / 7 %) umrechnen.",
    title: "Mehrwertsteuer-Rechner: Netto, Brutto und MwSt berechnen",
    description: "MwSt-Rechner für 19 % und 7 %: Netto zu Brutto, Brutto zu Netto und den Steuerbetrag herausrechnen.",
    h1: "Mehrwertsteuer-Rechner",
    intro: "Rechne zwischen Netto und Brutto um und sieh den Mehrwertsteuerbetrag. Wähle 19 % (Regelsatz) oder 7 % (ermäßigt) und die Richtung.",
    faq: [
      { q: "Wie rechne ich die Mehrwertsteuer aus dem Bruttopreis heraus?", a: "Brutto geteilt durch 1,19 (bei 19 %) ergibt den Nettobetrag. Die Differenz ist die Mehrwertsteuer. Beispiel: 119 € ÷ 1,19 = 100 € netto, 19 € MwSt." },
      { q: "Wann gelten 7 % statt 19 %?", a: "Der ermäßigte Satz von 7 % gilt unter anderem für Lebensmittel, Bücher und den Nahverkehr. Der Regelsatz von 19 % für die meisten anderen Waren und Dienstleistungen." },
    ],
  },
  {
    slug: "dreisatz-rechner",
    key: "dreisatz",
    name: "Dreisatz-Rechner",
    tagline: "Proportional und antiproportional mit dem Dreisatz rechnen.",
    title: "Dreisatz-Rechner: proportional und antiproportional berechnen",
    description: "Dreisatz online berechnen, proportional und antiproportional. Drei Werte eingeben, den vierten sofort sehen.",
    h1: "Dreisatz-Rechner",
    intro: "Der Dreisatz löst Verhältnisaufgaben: Wenn ein Wert einem anderen entspricht, was ergibt dann ein dritter Wert? Proportional steigt beides gemeinsam, antiproportional gegenläufig.",
    faq: [
      { q: "Was ist der Unterschied zwischen proportional und antiproportional?", a: "Proportional: mehr von A bedeutet mehr von B (mehr Ware, mehr Preis). Antiproportional: mehr von A bedeutet weniger von B (mehr Arbeiter, weniger Zeit)." },
    ],
  },
  {
    slug: "zinseszinsrechner",
    key: "zinseszins",
    name: "Zinseszinsrechner",
    tagline: "Kapitalwachstum mit Zinseszins und Sparrate berechnen.",
    title: "Zinseszinsrechner: Kapitalwachstum und Sparplan berechnen",
    description: "Zinseszins online berechnen: Startkapital, Sparrate, Zinssatz und Laufzeit eingeben und Endkapital plus Zinsertrag sehen.",
    h1: "Zinseszinsrechner",
    intro: "Sieh, wie dein Kapital über die Jahre mit Zinseszins wächst. Optional mit jährlicher Sparrate. Der Rechner zeigt Endkapital, Eingezahltes und den reinen Zinsertrag.",
    faq: [
      { q: "Wie wirkt der Zinseszins?", a: "Zinsen werden mitverzinst. Aus 1.000 € zu 5 % werden nach einem Jahr 1.050 €, im zweiten Jahr gibt es 5 % auf 1.050 €, also schon 1.102,50 €. Über lange Laufzeiten wächst der Effekt stark." },
    ],
  },
  {
    slug: "stundenlohn-rechner",
    key: "stundenlohn",
    name: "Stundenlohn-Rechner",
    tagline: "Monatsgehalt in Stundenlohn umrechnen und zurück.",
    title: "Stundenlohn-Rechner: Gehalt in Stundenlohn umrechnen",
    description: "Stundenlohn aus dem Monatsgehalt berechnen oder umgekehrt. Wochenstunden eingeben und Stunden-, Monats- und Jahreswert sehen.",
    h1: "Stundenlohn-Rechner",
    intro: "Rechne dein Monatsgehalt in den Stundenlohn um oder umgekehrt. Grundlage sind die Wochenstunden, umgerechnet auf rund 4,33 Wochen pro Monat.",
    faq: [
      { q: "Wie rechne ich Monatsgehalt in Stundenlohn um?", a: "Monatsgehalt geteilt durch (Wochenstunden × 4,33). Beispiel: 3.000 € bei 40 h ergibt rund 17,31 € pro Stunde." },
    ],
  },
  {
    slug: "rabattrechner",
    key: "rabatt",
    name: "Rabattrechner",
    tagline: "Rabatt, Endpreis und Ersparnis schnell ausrechnen.",
    title: "Rabattrechner: Endpreis und Ersparnis berechnen",
    description: "Rabatt online berechnen: Endpreis nach Prozent-Rabatt oder den Rabatt aus Original- und Endpreis bestimmen.",
    h1: "Rabattrechner",
    intro: "Gib den Originalpreis ein und entweder den Rabatt in Prozent oder den bekannten Endpreis. Der Rechner zeigt Endpreis, Ersparnis und Rabattprozentsatz.",
    faq: [
      { q: "Wie berechne ich den Endpreis nach Rabatt?", a: "Originalpreis mal (1 minus Rabatt ÷ 100). Beispiel: 100 € mit 20 % Rabatt = 100 × 0,8 = 80 €." },
    ],
  },
  {
    slug: "arbeitszeitrechner",
    key: "arbeitszeit",
    name: "Arbeitszeitrechner",
    tagline: "Arbeitszeit aus Beginn, Ende und Pause berechnen.",
    title: "Arbeitszeitrechner: Arbeitszeit aus Beginn, Ende und Pause",
    description: "Arbeitszeit berechnen: Beginn, Ende und Pause eingeben und die Netto-Arbeitszeit in Stunden und Minuten sehen.",
    h1: "Arbeitszeitrechner",
    intro: "Gib Beginn, Ende und die Pause ein, der Rechner zeigt deine Netto-Arbeitszeit in Stunden und Minuten sowie als Dezimalstunden. Auch über Mitternacht hinweg.",
    faq: [
      { q: "Wie rechne ich die Arbeitszeit aus?", a: "Ende minus Beginn minus Pause. Beispiel: 08:00 bis 17:00 mit 60 Minuten Pause ergibt 8 Stunden." },
      { q: "Was sind Dezimalstunden?", a: "Die Arbeitszeit als Kommazahl, zum Beispiel 7 Stunden 30 Minuten = 7,5 Stunden. Praktisch für die Abrechnung." },
    ],
  },
  {
    slug: "quadratmeter-berechnen",
    key: "flaeche",
    name: "Quadratmeter-Rechner",
    tagline: "Fläche und Umfang aus Länge und Breite berechnen.",
    title: "Quadratmeter berechnen: Fläche aus Länge und Breite",
    description: "Quadratmeter berechnen: Länge und Breite eingeben und Fläche in m² sowie den Umfang sehen.",
    h1: "Quadratmeter berechnen",
    intro: "Für eine rechteckige Fläche zählt Länge mal Breite. Gib beide Maße in Metern ein, der Rechner zeigt die Fläche in Quadratmetern und den Umfang.",
    faq: [
      { q: "Wie berechne ich Quadratmeter?", a: "Länge mal Breite in Metern. Beispiel: 4 m × 5 m = 20 m²." },
    ],
  },
  {
    slug: "spritkosten-rechner",
    key: "spritkosten",
    name: "Spritkosten-Rechner",
    tagline: "Spritkosten einer Strecke und pro Person berechnen.",
    title: "Spritkosten berechnen: Kosten pro Strecke und pro Person",
    description: "Spritkosten berechnen: Strecke, Verbrauch und Spritpreis eingeben und Gesamtkosten, Kosten pro Person und Liter sehen.",
    h1: "Spritkosten berechnen",
    intro: "Gib die Strecke, den Verbrauch und den Spritpreis ein, der Rechner zeigt die Kraftstoffkosten, den Verbrauch in Litern und bei Fahrgemeinschaften die Kosten pro Person.",
    faq: [
      { q: "Wie berechne ich die Spritkosten?", a: "Strecke ÷ 100 × Verbrauch ergibt die Liter, mal Spritpreis die Kosten. Beispiel: 300 km bei 7 L/100 km und 1,80 € = 37,80 €." },
    ],
  },
  {
    slug: "massstab-rechner",
    key: "massstab",
    name: "Maßstab-Rechner",
    tagline: "Zwischen realer Länge und Modell-/Kartenmaß umrechnen.",
    title: "Maßstab-Rechner: reale Länge und Modellmaß umrechnen",
    description: "Maßstab berechnen: Maßstab 1:X eingeben und zwischen realer Länge und Modell- oder Kartenmaß umrechnen.",
    h1: "Maßstab-Rechner",
    intro: "Rechne mit einem Maßstab 1:X zwischen realer Länge und Modell- oder Kartenmaß um, in beide Richtungen. Praktisch für Modellbau, Landkarten und Pläne.",
    faq: [
      { q: "Wie rechne ich mit dem Maßstab um?", a: "Reale Länge geteilt durch den Maßstabsfaktor ergibt das Modellmaß. Beispiel: bei 1:87 werden aus 870 cm real 10 cm im Modell." },
    ],
  },
];
